import { RootState } from "../../../core/store";
import { PORT_CALLS_REPORT, TPortCallsReportSliceState, TReportRequestParams } from "../types/downloadTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: TPortCallsReportSliceState = {
    portCallsReportData: null,
    portCallsReportLoading: false,
    portCallsReportError: null,
};

const portCallsReportSlice = createSlice({
    name: PORT_CALLS_REPORT,
    initialState,
    reducers: {
        submitPortCallsReportRequestAction: (state: TPortCallsReportSliceState, _: PayloadAction<TReportRequestParams>) => {
            state.portCallsReportLoading = true;
            state.portCallsReportError = null;
            state.portCallsReportData = null;
        },
        submitPortCallsReportSuccessAction: (state: TPortCallsReportSliceState, { payload: data }: PayloadAction<any>) => {
            state.portCallsReportLoading = false;
            state.portCallsReportData = data;
            state.portCallsReportError = null;
        },
        submitPortCallsReportErrorAction: (state: TPortCallsReportSliceState, { payload: error }: PayloadAction<any>) => {
            state.portCallsReportLoading = false;
            state.portCallsReportData = null;
            state.portCallsReportError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        },
        clearPortCallsReportStateAction: (state: TPortCallsReportSliceState) => {
            state.portCallsReportLoading = false;
            state.portCallsReportData = null;
            state.portCallsReportError = null;
        },
    },
});

export const portCallsReportActions = {
    ...portCallsReportSlice.actions
};

export default portCallsReportSlice.reducer;

export const selectPortCallsReportData = (state: RootState) =>
    state.portCallsReportSlice.portCallsReportData;
export const selectPortCallsReportLoading = (state: RootState) =>
    state.portCallsReportSlice.portCallsReportLoading;
export const selectPortCallsReportError = (state: RootState) =>
    state.portCallsReportSlice.portCallsReportError;
